import React from "react";
import Dashboard from "../../components/dashboard/Dashboard";

const HomePage = ({ loginPageData }) => {
  return (
    <>
      <Dashboard loginPageData={loginPageData} />
    </>
  );
};

export default HomePage;
